<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1 style="padding-top:100px; padding-bottom:20px;">Acknowledgment</h1>
<p style="text-align: center;">I would like to thank my boyfriend, Steven Gill. And also to Nikki Main at Austin Macauley Publishers.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?6e86c998